import {
  // FETCH_ACCOUNT_INFO_SUCCESS,
  FETCH_ACCOUNT_INFO_ERROR,
  RESET_POINT_BALANCE,
  SET_POINTS_BALANCE,
} from '../constant';
// import { logErrorMessage } from './LogErrorMessage';
import { getDataFromService } from '../../service';
import { generatePath } from 'react-router';
import {TP_BALANCE} from "../../common/constant/app.properties";
const {
  REACT_APP_SERVICE_URL,
} = window.weeksWebCloudConfig;

export const fetchAccountInfoError = () => ({
  type: FETCH_ACCOUNT_INFO_ERROR,
});

/** Dispatches Account Info Response Object */
export const getAccountInfo = customerId => async (dispatch) => {
  const memberUrl = generatePath(`${REACT_APP_SERVICE_URL}${TP_BALANCE}`, {
    customerId,
  });
  //const memberUrl = `${REACT_APP_SERVICE_URL}/rcio/${leadId}/ownerships/balance`;
  const serviceResponse = await getDataFromService({
    url: memberUrl,
    method: 'GET',
    customerID: customerId,
  });
  if (serviceResponse.status === 200) {
    /**
     * error messsage status check logic changed.
     * Always we have to check the status.
     */
    dispatch({type: SET_POINTS_BALANCE, payload: serviceResponse.data});
  } else {
    dispatch(fetchAccountInfoError());
    // dispatch(logErrorMessage(serviceResponse, 'Trip count service'));
  }
};

export const resetPointBalance = () => async (dispatch) => {
  dispatch({ type: RESET_POINT_BALANCE, payload: {} });
};
